export const PER_PAGE = 12;

export class RelayConnection {
  constructor() {
    this.edges = [];
    this.pageInfo = {
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      endCursor: null,
    };
  }
}
